// import external dependencies
import 'jquery';

// Import everything from autoload
import '../../autoload/_bootstrap.js';

import Router from '../../util/Router';
import pageTemplate from './page';

/** Populate Router instance with DOM routes */
const routes = new Router({
  pageTemplate,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/main.js